import { render, staticRenderFns } from "./ConfigTabs.vue?vue&type=template&id=7012dfd9&scoped=true&"
import script from "./ConfigTabs.vue?vue&type=script&lang=js&"
export * from "./ConfigTabs.vue?vue&type=script&lang=js&"
import style0 from "./ConfigTabs.vue?vue&type=style&index=0&id=7012dfd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7012dfd9",
  null
  
)

export default component.exports